import { useEffect, useState } from 'react';
import { SplashScreen } from '@/components/SplashScreen';
import { RELOAD_DEBOUNCE_MS } from '@/lib/chunkReload';

// Shown while a chunk-error reload is underway. If the page is still open
// after the window, the reload was cancelled, so surface the error instead.
export function ChunkReloadSplashScreen({ error }: { error: unknown }) {
  const [reloadCancelled, setReloadCancelled] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setReloadCancelled(true), RELOAD_DEBOUNCE_MS);
    return () => clearTimeout(timer);
  }, []);

  if (reloadCancelled) {
    throw error;
  }
  return <SplashScreen />;
}
